module.exports = {
      id: "envelope-usage",
      viewBox: "0 0 24 24",
      url: "/" + "svg-sprite-e82dc0c57c0a843613ac9ad873433208.svg#envelope",
      toString: function () {
        return this.url;
      }
    }